import iso_date from '../../assets/iso_date.svg';
import '../../styles/days.scss';

const One = () => (
  <div className='full-image days'>
    <img src={iso_date} alt='iso_date' />
  </div>
);

export default One;
